import { createI18n } from 'vue-i18n'
import fi from './fi-FI.json'
import zh from './zh-CN.json'
import en from './en-US.json'

const saved = localStorage.getItem('qc_lang') || 'fi'

const i18n = createI18n({
  legacy: false,
  locale: saved,
  fallbackLocale: 'fi',
  globalInjection: true,
  messages: { fi, zh, en },
})

export function setLang(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('qc_lang', lang)
  document.documentElement.lang = lang
}

document.documentElement.lang = saved

export default i18n
